import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'notification-button',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  public buttonClass: string;

  @Input()
  isAccepted: boolean = false;

  @Input()
  isChangePetition: boolean = false;

  @Input()
  notificationBodyText: string;

  @Input()
  notificationTitleText: string;

  @Input()
  tooltip: string;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
    this.buttonClass = this.isAccepted ? "btn btn-info mr-1" : "btn btn-danger mr-1";
  }

  showNotificationModal(content: any) {
    this.modalService.open(content);
  }

}
